<template>
  <div class="signin-main">
    <div class="signin-container">
        <div class="signin-hold">
            <h1 class="green-text">Please wait until we redirect to your portal !</h1> 
        </div>        
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "redirectpageifexist",
  data: function() {
    return {
      username: this.$route.params.email,
      portal_url:null,
    };
  },
created(){
    this.redirectif();
},
methods:{
    redirectif(){
        axios
        .get(
          process.env.VUE_APP_BASEURL+
            "/tenantsubscription/Providerurl/"+this.username
        )
        .then(response => {
          console.log(response);
            this.portal_url="https://"+response.data;
            window.location.replace(this.portal_url); 
            
        });
    }
}

};
</script>





